// actions/decor.ts — M1
import { defineAction } from '../define';
import { g } from '../guard';
import type { TileXY } from '../../types/geom';
import type { ItemId } from '../../types/ids';
import type { ItemView } from '../../types/items';
import type { SpaceId } from '../../types/space';
import type { Rot } from '@whiskerton/content';
declare module '../registry' {
  interface ActionMap {
    'furniture.place': { req: { item: ItemId; space: SpaceId; at: TileXY; rot: Rot }; res: { item: ItemView } };
    'furniture.move': { req: { item: ItemId; at: TileXY; rot: Rot }; res: { item: ItemView } };
    'furniture.store': { req: { item: ItemId; to: 'pockets' | 'storage' }; res: { item: ItemView } };
    'room.surface': { req: { item: ItemId; room: number }; res: { returned: ItemView } };
  }
}
export const furniturePlace = defineAction('furniture.place', g.obj({ item: g.id<ItemId>('i'), space: g.space, at: g.tile, rot: g.rot }));
export const furnitureMove = defineAction('furniture.move', g.obj({ item: g.id<ItemId>('i'), at: g.tile, rot: g.rot }));
export const furnitureStore = defineAction('furniture.store', g.obj({ item: g.id<ItemId>('i'), to: g.lit('pockets', 'storage') }));
export const roomSurface = defineAction('room.surface', g.obj({ item: g.id<ItemId>('i'), room: g.int(0, 9) }));
